import React from 'react';
import { AgGridReact } from "ag-grid-react";

export const Client = () => {
    const columnDefs = [
        { headerName: 'Client Name', field: 'client' },
        { headerName: 'MTD%', field: 'mtd', editable: false,cellStyle: { textAlign: "right" },headerClass: "text-end" },
        { headerName: 'QTD%', field: 'qtd', editable: false,cellStyle: { textAlign: "right" } ,headerClass: "text-end"},
        { headerName: 'YTD%', field: 'ytd', editable: false,cellStyle: { textAlign: "right" },headerClass: "text-end" }
    ];

    const rowData = [
        { client: "Peter", mtd: 5.67, qtd: 12.34, ytd: 28.90 },
        { client: "Ray Dalio", mtd: 3.21, qtd: 8.45, ytd: 19.78 },
        { client: "Cathie Wood", mtd: 4.12, qtd: 10.56, ytd: 22.34 },
        { client: "Peter Lynch", mtd: 2.34, qtd: 7.89, ytd: 18.67 },
        { client: "Carl Icahn", mtd: 1.89, qtd: 6.45, ytd: 15.23 }
    ];

    const defaultColDef = {
        flex: 1,
        minWidth: 150,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        editable: true,
        resizable:true
    };

    return (
        <div className="container mt-5">
            <h5 style={{ color: '#037196' }}>Client Performance</h5>
            <div
                className="ag-theme-alpine"
                style={{ height: "50vh", width: "100%" }}
            >
                <AgGridReact
                    rowData={rowData}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                />
            </div>
        </div>
    );
};